export const isFile = (file) => {
  return file instanceof File;
};

export const isBlob = (file) => {
  return file instanceof Blob;
};

export const isBase64= (file) => {
  return typeof file === 'string' && file.startsWith('data:');
};
